<template>
  <div class="container">
    <v-expansion-panels>
      <v-expansion-panel isActive="true">
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
                <v-autocomplete 
                    v-bind:items="accounts" 
                    v-model="selectedAccount"
                    return-object
                    
                    item-text="name" 
                    label="Πελάτης"
                    clearable>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field 
                    v-model="tradeNameFilterValue"
                    type="text"
                    label="Διακ. Τίτλος"
                    clearable>
                </v-text-field>
            </v-col>
            
        </v-row>

        <v-row>
            <v-col cols="12" sm="6">
              <v-text-field 
                    v-model="representativeFilterValue"
                    type="text"
                    label="Αντιπρόσωπος"
                    clearable>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field 
                    v-model="distributorFilterValue"
                    type="text"
                    label="Διανομέας"
                    clearable>
                </v-text-field>
                
            </v-col>
            
        </v-row>

          <v-row class="my-2" cols="12" align="center" justify="center">
            <v-btn 
                class="mx-2"
                color="success" 
                @click="getData" 
                v-bind:loading="getDataButtonDisabled"
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                class="mx-2"
                color="warning" 
                @click="clearFilters" 
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>

        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :items="items"
      :sort-by="['date']"
      :sort-desc="true"
      class="elevation-1 my-2"
      disable-filtering
      >
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Αποτελέσματα</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          
          <v-spacer></v-spacer>
          <v-btn color="success" dark class="mb-2" @click="excelPlease" v-show="showExport" v-bind:loading="getExcelButtonDisabled">
            ΕΞΑΓΩΓΗ
          </v-btn>

        </v-toolbar>
      </template>
      
      <template v-slot:[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>


      <template v-slot:[`item.debit`]="{ item }">
        {{ formatMoney(item.debit) }}
      </template>

      <template v-slot:[`item.credit`]="{ item }">
        {{ formatMoney(item.credit) }}
      </template>

      <template v-slot:[`item.oldBalance`]="{ item }">
        {{ formatMoney(item.oldBalance) }}
      </template>

      <template v-slot:[`item.newBalance`]="{ item }">
        {{ formatMoney(item.newBalance) }}
      </template>


    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      allerrors : {
        
      },

      dialog: false,

      headers: [
        {
          text: 'Πελάτης',
          align: 'start',
          value: 'customer',
        },
        {
          text: 'Υποκατάστημα',
          align: 'start',
          value: 'branch_name',
        },
        {
          text: 'Αποθήκη',
          align: 'start',
          value: 'warehouse_name',
        },
        { 
          text: 'Κωδικός', 
          align: 'left',
          value: 'code_eidous' 
        },
        { 
          text: 'Είδος', 
          align: 'left',
          value: 'eidos' 
        },
        { 
          text: 'Ποσότητα', 
          align: 'right',
          value: 'qnt',
          exportTransformer: (cell) => cell.replace('.', ',')  
        },
        { 
          text: 'Καθαρή Αξία', 
          align: 'right',
          value: 'kathari_aksia',
          exportTransformer: (cell) => cell.replace('.', ',')
        },
        { 
          text: 'ΦΠΑ', 
          align: 'right',
          value: 'taxes',
          exportTransformer: (cell) => cell.replace('.', ',') 
        },
        { 
          text: 'Μικτή αξία', 
          align: 'right',
          value: 'synolo',
          exportTransformer: (cell) => cell.replace('.', ',') 
        },
        { 
          text: 'Μέσος όρος', 
          align: 'right',
          value: 'average',
          exportTransformer: (cell) => cell.replace('.', ',') 
        },
        { 
          text: 'Μέσος όρος έκπτωσης', 
          align: 'right',
          value: 'discount_average',
          exportTransformer: (cell) => cell.replace('.', ',') 
        },
        { 
          text: 'Διακ. Τίτλος', 
          align: 'right',
          value: 'trade_name' 
        },
        { 
          text: 'Υποκατάστημα πελάτη', 
          align: 'right',
          value: 'cus_branch_name' 
        },
        { 
          text: 'Διανομέας', 
          align: 'right',
          value: 'distributor' 
        },
        { 
          text: 'Αντιπρόσωπος', 
          align: 'right',
          value: 'representative' 
        }
      ],

      items: [],


      documentTypes: [],
      accounts: [],

      selectedAccount: {},

      documentTypeFilter: null,

      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,

      tradeNameFilterValue: null,
      distributorFilterValue: null,
      representativeFilterValue: null,

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,

      menu2: null,
      menu1: null,


    }),

    watch: {

    },

    created () {
      this.initialize()
    },

    computed: {
      showExport() {
        return this.items?.length > 0
      }
    },

    methods: {

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xls')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      formatMoney(amount) {
        if (amount == null)
          amount = 0.0

        return amount.toFixed(2)
      },


      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')
        
        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        this.documentIssueDateStopFilter = this.$localDateString(today)

        

        // this.getData();
        this.getFilterValues()
      },

      getFilterValues() {
        this.accounts = axios.get('/api/accounts')
            .then(response => {
                this.accounts = response.data
            }).catch(error => console.log(error))
      },
      
      getRequestParams() {
        let out = {
          
        }


        if (this.documentIssueDateStartFilter != null)
          out.issue_date_start = this.documentIssueDateStartFilter

        if (this.documentIssueDateStopFilter != null)
          out.issue_date_stop = this.documentIssueDateStopFilter

        if (this.selectedAccount != null)
            out.customer_id = this.selectedAccount.id

        if (this.tradeNameFilterValue?.length > 0)
          out.trade_name = this.tradeNameFilterValue

        if (this.distributorFilterValue?.length > 0)
          out.distributor = this.distributorFilterValue

        if (this.representativeFilterValue?.length > 0)
          out.representative = this.representativeFilterValue
        
        return out
      },

      getData() {
        this.allerrors = {}

        const params = this.getRequestParams()

        if (params.issue_date_start == null || params.issue_date_stop == null)
          return


        this.getDataButtonDisabled = true;
        axios.post(
            '/api/reports/sales-per-customer', 
            {
                params: params
            }
        )
        .then(response => this.items = response.data)
        .finally(() => { this.getDataButtonDisabled = false; })
        .catch(error => { 
          if (error.response.data)
              this.allerrors = error.response.data.errors
         })
        
      },


      clearFilters() {
        this.documentIssueDateStartFilter = null
        this.documentIssueDateStopFilter = null
      }
    }
  }
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
</style>